import {
  Button,
  Modal,
  Skeleton,
  Form,
  Input,
  InputNumber,
  Radio,
  RadioChangeEvent,
} from "antd";
import { formStyle, layout, ContainerModalBtn, btnStyle } from "../styles";
import { useApartamento } from "../hooks/useApto";
import { Apartamento } from "../../../interfaces/Apartamento";
import { useEffect, useRef, useState } from "react";
import { useAtualizarApto } from "../hooks/useAtualizarApto";
import { useNavigate } from "react-router-dom";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";

export default function ModalEditar({
  isModalOpen,
  handleFechar,
  aptoId,
}: any) {
  const [formAp] = Form.useForm();
  // Referencia de edição
  const changing = useRef<boolean>(false);
  const { isLoading, apartamento } = useApartamento(aptoId, isModalOpen);
  const { atualizarApto, error, success } = useAtualizarApto();

  // Estado inicial de Cadastro Inicial Apartamento
  const [ap, setAp] = useState<Apartamento>({});

  // UseStates necessários para o passo de cadastro de apartamento e busca de empreendimento cadastrado
  const [possuiVaranda, setPossuiVaranda] = useState<number>();
  const [estacionamento, setEstacionamento] = useState<number>();
  const [terreo, setTerreo] = useState<number>();

  // Função que armazena os dados alterados de Apartamento
  const apartamentoChange = (changedValues: Partial<any>, allValues: any) => {
    changing.current = true;
    if (changing.current) {
      setAp(allValues);
    }
  };

  // Função que armazena o dado selecionado da varanda
  const possuiVarandaChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setPossuiVaranda(e.target.value);
  };

  // Função que armazena o dado selecionado do estacionamento
  const estacionamentoChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setEstacionamento(e.target.value);
  };

  // Função que armazena o dado selecionado do terreo
  const terreoChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setTerreo(e.target.value);
  };

  // Atualiza o estado do formulário somente quando todos os dados estiverem disponíveis
  useEffect(() => {
    if (isModalOpen) {
      if (apartamento) {
        // Atualiza os dados do formulário com as informações do apartamento e cota

        setAp({
          id: apartamento?.id,
          nome: apartamento?.nome,
          capacidade: apartamento?.capacidade,
          quartos: apartamento?.quartos,
          banheiros: apartamento?.banheiros,
          metragem: apartamento?.metragem,
          varanda: apartamento?.varanda,
          terreo: apartamento?.terreo,
          estacionamento: apartamento?.estacionamento,
        });
      }
    }
  }, [isModalOpen, apartamento]); // Dependências: isModalOpen e apartamento

  // Usar setFieldsValue quando o cadastroInicial mudar
  useEffect(() => {
    if (!formAp) {
      return;
    }
    formAp.setFieldsValue({
      id: ap.id,
      nome: ap.nome,
      capacidade: ap.capacidade,
      quartos: ap.quartos,
      banheiros: ap.banheiros,
      metragem: ap.metragem,
      varanda: ap.varanda,
      terreo: ap.terreo,
      estacionamento: ap.estacionamento,
    });
  }, [formAp, ap]);

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();
  useEffect(() => {
    if (isModalOpen && success && !successDisplayed) {
      // Mensagem de sucesso
      const msgSuccess = "Apartamento atualizado com sucesso!";
      showSuccess(msgSuccess);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        navigate(0);
      }, 2000);
    }

    if (isModalOpen && error && !errorDisplayed) {
      // Mensagem de erro
      let msgError = "Não foi possível atualizar o apartamento!";
      showError(msgError);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
      }, 3000);
    }

    // Reset quando o modal fecha
    if (!isModalOpen) {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    navigate,
  ]);

  return (
    <>
      <Modal open={isModalOpen} onCancel={handleFechar} footer={null}>
        {isLoading && <Skeleton active />}
        {!isLoading && apartamento && (
          <>
            <>{errorContextHolder}</>
            <>{successContextHolder}</>
            {/* Apartamento */}
            <Form
              {...layout}
              form={formAp}
              initialValues={ap}
              onValuesChange={(changedValues, allValues) =>
                apartamentoChange(changedValues, allValues)
              }
              name="apartamento"
              style={formStyle}
            >
              <h1>Apartamento</h1>
              <Form.Item
                name={["nome"]}
                label="Apartamento "
                className="formItems"
              >
                <Input />
              </Form.Item>

              <Form.Item
                name={["capacidade"]}
                label="Capacidade "
                className="formItems"
              >
                <InputNumber min={0} />
              </Form.Item>
              <Form.Item
                name={["quartos"]}
                label="Quartos "
                className="formItems"
              >
                <InputNumber min={0} />
              </Form.Item>
              <Form.Item
                name={["banheiros"]}
                label="Banheiros "
                className="formItems"
              >
                <InputNumber min={0} />
              </Form.Item>
              <Form.Item
                name={["metragem"]}
                label="Metragem "
                className="formItems"
              >
                <InputNumber min={0} />
              </Form.Item>
              <Form.Item
                name={["varanda"]}
                label="Varanda "
                className="formItems"
              >
                <Radio.Group
                  onChange={possuiVarandaChange}
                  value={possuiVaranda}
                >
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                  <Radio value={2}>Não Sei</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item name={["terreo"]} label="Térro " className="formItems">
                <Radio.Group onChange={terreoChange} value={terreo}>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                  <Radio value={2}>Não Sei</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name={["estacionamento"]}
                label="Estacionamento "
                className="formItems"
              >
                <Radio.Group
                  onChange={estacionamentoChange}
                  value={estacionamento}
                >
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                  <Radio value={2}>Não Sei</Radio>
                </Radio.Group>
              </Form.Item>
            </Form>
            <ContainerModalBtn>
              {/* Botão para enviar os dados */}
              <Button
                type="primary"
                onClick={() => atualizarApto(apartamento?.id, ap)}
                style={btnStyle}
                size="large"
              >
                Atualizar
              </Button>
            </ContainerModalBtn>
          </>
        )}
      </Modal>
    </>
  );
}
